module.exports = __webpack_public_path__ + "img/bannerimg5.3f18afb8.png";